module.exports = __webpack_public_path__ + "static/media/3.e8c441b5.png";